import sendRecentSearchData from "MMT-UI/recentSearch";
import fecha from "fecha";
import {
  APP_LANGUAGE,
  COUNTRY,
  CUSTOMER_PROFILE,
  CUSTOMER_REGION,
  ONWARD_JOURNEY,
  RAILS_LOB,
  RECENT_SEARCH_RAILS_COLUMN
} from "../../../../constants/TrainConstants";

export const searchConnector = (response) => {
  const {
    fromDateTime,
    fromCity,
    toCity,
    fromCityName,
    toCityName,
  } = response;

  const formattedDate = fecha.parse(fromDateTime, "YYYYMMDD");
  const fromCityCode = fromCity.toUpperCase();
  const toCityCode = toCity.toUpperCase();
  try {
    sendRecentSearchData([
      {
        column: RECENT_SEARCH_RAILS_COLUMN,
        searchContext: {
          language: APP_LANGUAGE,
          region: CUSTOMER_REGION,
          profile: CUSTOMER_PROFILE,
          timestamp: new Date().getTime(),
          lob: RAILS_LOB,
          lobCategory: RAILS_LOB,

          fromDateTime: {
            ts: formattedDate.getTime(),
            zone: COUNTRY.TIMEZONE,
            str: fecha.format(formattedDate, "DD-MM-YYYY HH:MM:ss"),
          },
          from: {
            lobCity: fromCityCode,
            cityName: fromCityName,
            lobCountry: COUNTRY.NAME,
            countryCode: COUNTRY.CODE
          },
          to: {
            lobCity: toCityCode,
            cityName: toCityName,
            lobCountry: COUNTRY.NAME,
            countryCode: COUNTRY.CODE
          },
          journeyType: ONWARD_JOURNEY,
          meta: {
            deeplink: `https://www.makemytrip.com/railways/search/railsListingPage?from_city=${fromCityName}&from=${fromCityCode}&from_station=${fromCityName}&to_city=${toCityName}&to=${toCityCode}&to_station=${toCityName}&departure=${formattedDate}`,
            universalText: `Trains from ${fromCityName} to ${toCityName} on ${fecha.format(formattedDate, 'MMM D')}`
          },
        }
      }
    ]).then(_ => {});
  } catch (e) {
    console.log("Error in searchConnector : ",e);
  }
};
